import { opportunityFetch } from "@/lib/opportunity/opportunityFetch";
import type { DocBlock } from "@/lib/document-builder/blocks/blockTypes";
import type { DocVariableSnapshot } from "@/lib/document-builder/versions/snapshotTypes";
import type { DocVariableValues } from "@/lib/document-builder/variables/variableFill";
import { documentFetch } from "@/lib/document/docClient";

export type DocFormTemplateLink = {
  id: string;
  organization_id: string;
  form_template_id: string;
  document_id: string;
  published_version_id: string;
  created_at: string;
  updated_at: string;
};

export type OrgFormBridgeFillContext = {
  bridged: true;
  document_id: string;
  version_id: string;
  document_name: string;
  version_number: number;
  blocks: DocBlock[];
  variables: DocVariableSnapshot[];
  variable_values: DocVariableValues;
  block_id_to_variable_key: Record<string, string>;
};

export function getOrgFormBridgeFillContext(instanceId: string) {
  const q = new URLSearchParams({ instance_id: instanceId });
  return opportunityFetch<
    | { ok: true; bridged: false }
    | ({ ok: true } & OrgFormBridgeFillContext)
    | { ok: false; error: string }
  >(`/api/opportunity/form-instance-bridge-context?${q.toString()}`, { method: "GET" });
}

export function listDocFormBridgeLinks(documentId: string) {
  const q = new URLSearchParams({ document_id: documentId });
  return documentFetch<{ ok: true; links: DocFormTemplateLink[] }>(
    `/api/doc/form-bridge-list?${q.toString()}`,
    { method: "GET" },
  );
}

export function getDocFormBridge(formTemplateId: string) {
  const q = new URLSearchParams({ form_template_id: formTemplateId });
  return documentFetch<{
    ok: true;
    bridged: boolean;
    link: DocFormTemplateLink | null;
  }>(`/api/doc/form-bridge-get?${q.toString()}`, { method: "GET" });
}

export function upsertDocFormBridge(body: {
  form_template_id: string;
  document_id: string;
  published_version_id: string;
}) {
  return documentFetch<{ ok: true; link: DocFormTemplateLink }>("/api/doc/form-bridge-upsert", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}
